"use client";

import Footer from "@/components/shared/Footer";
import TopNav from "@/components/shared/TopNav";
import HeroSection from "./components/HeroSection";
import WallSection from "@/components/shared/WallSection";
import TimeSection from "./components/TimeSection";
import LargestVerifiedSection from "./components/LargestVerifiedSection";
import TabsSection from "./components/TabsSection";
import PricingSection from "@/components/shared/PricingSection";
import FaqSection from "@/components/shared/FaqSection";
import NextCallsSection from "@/components/shared/NextCallsSection";

export default function HomePageComponent() {
  return (
    <div>
      <TopNav />
      <main>
        <HeroSection />
        <TimeSection />
        <LargestVerifiedSection />
        <TabsSection />
        <WallSection />
        <PricingSection />
        <FaqSection />
        <NextCallsSection />
      </main>
      <Footer />
    </div>
  );
}
